import { Component } from '@angular/core';
import { iBisBaseComponent } from '@dohu/ibis-common';
import { ProxyService } from '../../../service/proxy.service';
import { EditSpecializationService } from './edit-specialization.service';

@Component({
	selector: 'app-edit-specialization',
	templateUrl: './edit-specialization.component.html'
})
export class EditSpecializationComponent extends iBisBaseComponent {

	public declare edit: EditSpecializationService;
	constructor(public proxy: ProxyService) {
		super(proxy.specialization, proxy.lg, proxy.iui, proxy.activatedRoute);
	}
}
